import React, { useState } from "react";
import Button from "../components/Button";
import Input from "../components/Input";
import firebase from "firebase";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

const LoginWrapper = styled.div`
  display: flex;
  margin: auto;
  height: 100vh;
  justify-content: center;
  flex-direction: column;
  width: 360px;
  text-align: center;
  input {
    margin-bottom: 8px;
  }
  button {
    margin-top: 16px;
  }
`;

const Login = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const history = useHistory();
  const [error, setError] = useState("");

  const onRegister = async () => {
    setError("");
    setIsLoading(true);
    if (password !== password2) {
      setIsLoading(false);
      setError("Your passwords do not match!");
      return;
    }
    // Does the user exist in our list of users?
    const studentExists = await firebase
      .firestore()
      .collection("students")
      .where("email", "==", email)
      .get();

    if (studentExists.empty) {
      setIsLoading(false);
      setError(
        "This email cannot be used to sign in, send an email to contact@youngcoderz.com"
      );
      return;
    }

    if (studentExists.docs[0].data().uid) {
      setError("This account is already registered");
      return;
    }

    const newUser = await firebase
      .auth()
      .createUserWithEmailAndPassword(email, password);
    setIsLoading(false);
    await firebase
      .firestore()
      .collection("students")
      .doc(studentExists.docs[0].id)
      .update({ uid: newUser?.user?.uid, username });
    history.push("/home");
  };

  return (
    <LoginWrapper>
      <h2>Young Coderz Online</h2>
      <Input
        value={username}
        onChange={(e) => setUsername(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onRegister();
          }
        }}
        placeholder="Username"
      />
      <Input
        value={email}
        onChange={(e) => setEmail(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onRegister();
          }
        }}
        placeholder="Email"
      />
      <Input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onRegister();
          }
        }}
        placeholder="Password"
      />

      <Input
        type="password"
        value={password2}
        onChange={(e) => setPassword2(e.currentTarget.value)}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            onRegister();
          }
        }}
        placeholder="Confirm Password"
      />
      <Button onClick={onRegister} disabled={isLoading}>
        {isLoading ? "Registering..." : "Register"}
      </Button>
      {error && error}
    </LoginWrapper>
  );
};

export default Login;

// Styling for all pages
// Progress bar
// Leaderboard
// Session page
// Activity page

// fast styling for admin dashboard pages

// Creating parents/students
// Create class of students
// Create sessions for class
// Create activities for class / student

// View assignment
// Give or set points
